import { Component, Input } from '@angular/core';
import { Icons } from '../../../constants/icons.constants';
import { ButtonGroupType } from '../../../models/common';
import { CheckableRowsService } from '../../../services/table/checkable-rows/checkable-rows.service';

@Component({
    selector: 'lsq-table-checkbox-controls',
    template: `
        <div class="checkbox-controls">
            <div class="checkbox-controls-buttons">
                <lsq-button
                    appearance="secondary"
                    size="sm"
                    (buttonClick)="toggleSelectOptions()"
                    class="dropdown-button"
                    (clickOutside)="hideDropdown()"
                    [disabled]="
                        disabled ||
                        !checkableRowsService ||
                        (checkableRowsService.isLoading$ | async)
                    "
                    [buttonGroupType]="
                        hasActions && checkableRowsService?.checkedRows.length
                            ? buttonGroupType.First
                            : null
                    "
                >
                    <div class="checkbox-container">
                        <div class="checkbox-icon">
                            <lsq-checkbox
                                [ngModel]="
                                    checkableRowsService?.checkedRows.length == 0 ||
                                    checkableRowsService?.checkedRows.length == null
                                        ? false
                                        : checkableRowsService?.checkedRows.length ==
                                          checkableRowsService?.rowCount
                                "
                                [displayOnly]="true"
                                [disabled]="
                                    disabled ||
                                    !checkableRowsService ||
                                    (checkableRowsService.isLoading$ | async)
                                "
                                [partiallyChecked]="
                                    checkableRowsService?.checkedRows.length > 0 &&
                                    checkableRowsService?.checkedRows.length <
                                        checkableRowsService?.rowCount
                                "
                            ></lsq-checkbox>
                        </div>
                        <span class="selected-button-text">
                            {{
                                !checkableRowsService || (checkableRowsService.isLoading$ | async)
                                    ? 'Loading...'
                                    : (checkableRowsService.checkedRows.length | number) +
                                      ' selected'
                            }}
                        </span>
                    </div>
                </lsq-button>
                <lsq-button
                    *ngIf="hasActions && checkableRowsService?.checkedRows.length"
                    appearance="secondary"
                    [disabled]="
                        disabled ||
                        !checkableRowsService ||
                        (checkableRowsService.isLoading$ | async)
                    "
                    (buttonClick)="toggleActions()"
                    (clickOutside)="hideDropdown()"
                    [buttonGroupType]="buttonGroupType.Last"
                >
                    <div class="actions-button-text">
                        Actions
                        <lsq-icon
                            [type]="icons.FaSortDown"
                            height="12"
                            [style.marginLeft]="'1rem'"
                            [style.marginBottom]="'0.5rem'"
                        >
                        </lsq-icon>
                    </div>
                </lsq-button>
            </div>
            <div *ngIf="actionsExpanded" class="dropdown-wrapper">
                <div class="dropdown-box actions">
                    <ng-content></ng-content>
                </div>
            </div>

            <div *ngIf="selectOptionsExpanded" class="dropdown-wrapper">
                <div class="dropdown-box">
                    <lsq-button
                        appearance="secondary"
                        size="md"
                        (buttonClick)="handlePageSelectAllChange()"
                    >
                        <span
                            class="buttonText"
                            [ngSwitch]="checkableRowsService?.areAllPageRowsChecked$ | async"
                        >
                            <span *ngSwitchCase="false">
                                Select Page ({{ checkableRowsService?.currentPageRowCount }})
                            </span>
                            <span *ngSwitchCase="true"
                                >Deselect Page ({{
                                    checkableRowsService?.currentPageRowCount
                                }})</span
                            >
                        </span>
                    </lsq-button>
                    <lsq-button
                        appearance="secondary"
                        size="md"
                        (buttonClick)="handleSelectAllChange()"
                    >
                        <span
                            class="buttonText"
                            [ngSwitch]="
                                isFilteredSelectAll
                                    ? (checkableRowsService.areAllFilteredRowsChecked$ | async)
                                    : (checkableRowsService?.areAllRowsChecked$ | async)
                            "
                        >
                            <span *ngSwitchCase="false">
                                Select All ({{
                                    isFilteredSelectAll
                                        ? (checkableRowsService?.currentAllFilteredRowCount
                                          | number)
                                        : (checkableRowsService?.rowCount | number)
                                }})
                            </span>
                            <span *ngSwitchCase="true"
                                >Deselect All ({{
                                    isFilteredSelectAll
                                        ? (checkableRowsService?.currentAllFilteredRowCount
                                          | number)
                                        : (checkableRowsService?.rowCount | number)
                                }})</span
                            >
                        </span>
                    </lsq-button>
                </div>
            </div>
        </div>
    `,
    styleUrls: ['./lsq-table-checkbox-controls.component.scss']
})
export class LsqTableCheckboxControlsComponent {
    @Input() public checkableRowsService: CheckableRowsService;
    @Input() public disabled = false;
    @Input() public isFilteredSelectAll = false;
    @Input() public hasActions = false;

    public icons = Icons;
    public buttonGroupType = ButtonGroupType;

    public selectOptionsExpanded = false;
    public actionsExpanded = false;

    public toggleSelectOptions(): void {
        this.actionsExpanded = false;
        this.selectOptionsExpanded = !this.selectOptionsExpanded;
    }

    public toggleActions(): void {
        this.selectOptionsExpanded = false;
        this.actionsExpanded = !this.actionsExpanded;
    }

    public hideDropdown(): void {
        this.actionsExpanded = false;
        this.selectOptionsExpanded = false;
    }

    public handleSelectAllChange(): void {
        if (this.isFilteredSelectAll) {
            if (!this.checkableRowsService.areAllFilteredRowsChecked()) {
                this.checkableRowsService.checkAllFiltered();
            } else {
                this.checkableRowsService.uncheckAllFiltered();
            }
        } else {
            if (!this.checkableRowsService.areAllRowsChecked()) {
                this.checkableRowsService.checkAll();
            } else {
                this.checkableRowsService.uncheckAll();
            }
        }
        this.selectOptionsExpanded = false;
    }

    public handlePageSelectAllChange(): void {
        if (!this.checkableRowsService.areAllPageRowsChecked()) {
            this.checkableRowsService.checkPageAll();
        } else {
            this.checkableRowsService.uncheckPageAll();
        }
        this.selectOptionsExpanded = false;
    }
}
